import Icon from 'components/icons/Icon';

const MoreInfo = (props) => {
  const { isHydraZapr, ...restProps } = props;

  if (isHydraZapr) {
    return (
      <Icon width="16" height="16" viewBox="0 0 16 16" fill="none"  {...restProps}>
        <title>More Info</title>
        <g id="info_FILL0_wght400_GRAD0_opsz48 2">
          <circle id="Ellipse 1275" cx="7.99992" cy="7.99992" r="6.33333" stroke="#090708" strokeWidth="0.666667"/>
          <g id="Group 1073712920">
            <circle id="Ellipse 1276" cx="7.99992" cy="5.33341" r="0.666667" fill="#090708"/>
            <path id="Vector 665" d="M7.99976 8.00024V11.0002" stroke="#090708" strokeWidth="1.16667" strokeLinecap="round"/>
          </g>
        </g>
      </Icon>
    )
  }

  return (
  <Icon viewBox="0 0 36 36" {...restProps}>
    <title>More Info</title>
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fill="#707070">
        <path d="M24.6857143,30.0857143 L24.6857143,26.2285714 C24.6857143,25.7946429 24.3482143,25.4571429 23.9142857,25.4571429 L21.6,25.4571429 L21.6,13.1142857 C21.6,12.6803571 21.2625,12.3428571 20.8285714,12.3428571 L13.1142857,12.3428571 C12.6803571,12.3428571 12.3428571,12.6803571 12.3428571,13.1142857 L12.3428571,16.9714286 C12.3428571,17.4053571 12.6803571,17.7428571 13.1142857,17.7428571 L15.4285714,17.7428571 L15.4285714,25.4571429 L13.1142857,25.4571429 C12.6803571,25.4571429 12.3428571,25.7946429 12.3428571,26.2285714 L12.3428571,30.0857143 C12.3428571,30.5196429 12.6803571,30.8571429 13.1142857,30.8571429 L23.9142857,30.8571429 C24.3482143,30.8571429 24.6857143,30.5196429 24.6857143,30.0857143 Z M21.6,8.52244898 L21.6,4.84897959 C21.6,4.43571429 21.2625,4.11428571 20.8285714,4.11428571 L16.2,4.11428571 C15.7660714,4.11428571 15.4285714,4.43571429 15.4285714,4.84897959 L15.4285714,8.52244898 C15.4285714,8.93571429 15.7660714,9.25714286 16.2,9.25714286 L20.8285714,9.25714286 C21.2625,9.25714286 21.6,8.93571429 21.6,8.52244898 Z M36,18 C36,27.9375 27.9375,36 18,36 C8.0625,36 0,27.9375 0,18 C0,8.0625 8.0625,0 18,0 C27.9375,0 36,8.0625 36,18 Z" id="i"/>
      </g>
    </g>
  </Icon>
  )
};

export default MoreInfo;
